/* global axios */
import ApiClient from '../ApiClient';

class SuiteAPI extends ApiClient {
  constructor() {
    super('integrations/suite', { accountScoped: true });
  }

  connect({ suiteUrl }) {
    return axios.post(`${this.url}/auth`, { suite_url: suiteUrl });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  clients(params = {}) {
    return axios.get(`${this.url}/clients`, { params });
  }

  confirm({ clienteId, clienteNome }) {
    return axios.post(`${this.url}/confirm`, {
      cliente_id: clienteId,
      cliente_nome: clienteNome,
    });
  }

  extensions(params = {}) {
    return axios.get(`${this.url}/extensions`, { params });
  }

  softphone({ dark } = {}) {
    return axios.get(`${this.url}/softphone`, { params: { dark } });
  }

  clickToCall({ phoneNumber }) {
    return axios.post(`${this.url}/click_to_call`, {
      phone_number: phoneNumber,
    });
  }

  disconnect() {
    return axios.delete(this.url);
  }
}

export default new SuiteAPI();
